<template>
  <div class="bill-details" ref="container">


    <div class="my-promotion">
      <div class="header"  style="background-color: #ec5d59 !important;">
        <div class="name acea-row row-center-wrapper">
          <div style="font-size:0.5rem;">释放记录</div>
        </div>

      </div>
    </div>
    <div style="background-color:#fff;height:1.2rem;width:7.2rem;margin:0 auto;border-radius: 0.06rem;margin-top:-0.5rem;" >
          <!--<span class="num" style="height:1.1rem;border:1px solid #f1f1f1;font-size:0.3rem;width:25%;display:block;float:left;text-align:center;padding:0.1rem 0rem;" :key="index">
            <span style="height:0.1rem;display:block;">总共释放</span><br />{{all_money || 0}}
          </span>-->
      <span class="num" style="height:1.1rem;border:1px solid #f1f1f1;font-size:0.3rem;width:50%;display:block;float:left;text-align:center;padding:0.1rem 0rem;" :key="index">
            <span style="height:0.1rem;display:block;">已经释放</span><br />{{ed_money || 0}}
          </span>
      <!--<span class="num" style="height:1.1rem;border:1px solid #f1f1f1;font-size:0.3rem;width:25%;display:block;float:left;text-align:center;padding:0.1rem 0rem;" :key="index">
            <span style="height:0.1rem;display:block;">等待释放</span><br />{{last_money || 0}}
          </span>-->
      <span class="num" style="height:1.1rem;border:1px solid #f1f1f1;font-size:0.3rem;width:50%;display:block;float:left;text-align:center;padding:0.1rem 0rem;" :key="index">
            <span style="height:0.1rem;display:block;">每日释放</span><br />{{day_money || 0}}
          </span>


      <span style="clear:both;"></span>
    </div>
    <div class="sign-record">
      <div class="list" v-if="list.length > 0">
        <div class="item" v-for="(val, index) in list" :key="index">
          <div class="data" style="float:left;">{{ val.code }} </div>
          <div class="data" style="float:right;">{{ val.add_time_show }}</div>
          <div style="clear:both;"></div>
          <div class="listn">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ val.status_show }}</div>

              </div>
              <div style="width:100%;">
                <div class="name line1"></div>
                <!--<div style="color:#999;">总共释放：{{ val.growth }}</div>-->
                <div style="color:#999;">已经释放：{{ val.growth_ed }}</div>
                <!--<div style="color:#999;">等待释放：{{ val.growth_last }}</div>-->

                <!--<div style="color:#999;">总释放天：{{ val.all_num }}</div>-->
                <div style="color:#999;">已释放天：{{ val.ed_num }}天</div>
                <!--<div style="color:#999;">待释放天：{{ val.last_num }}</div>-->

                <div style="color:#999;">开始时间：{{ val.start_day_show }}</div>
                <div style="color:#999;">下次时间：{{ val.will_day_show }}</div>
                <div style="color:#999;" v-if="val.end_day_show!=''">结束时间：{{ val.end_day_show }}</div>
                <div style="color:#999;" v-if="val.cancel_time_show!=''">关闭时间：{{ val.cancel_time_show }}</div>
                <div style="width:100%;">

                  <div style="float:right;width:50%;text-align:right;" class="num" v-if="val.status==0">
                    每日：{{ val.growth_day}}
                  </div>
                  <div style="float:right;width:50%;text-align:right;" v-if="val.status==1">
                    每日：{{ val.growth_day}}
                  </div>
                  <div style="float:right;width:50%;text-align:right;" v-if="val.status==2">
                    每日：{{ val.growth_day}}
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="shoppingCart">
        <div  style="margin-top:0px;"
              class="noCart"
              v-if="showno === 0"
        >
          <div class="pictrue"><img src="@assets/images/noList.png" /></div>
        </div>
      </div>

    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .font-color-red-l {
    color:red !important;
  }
</style>
<script>
    import { getCommissionGrowth } from "../../api/user";
    import Loading from "@components/Loading";
    export default {
        name: "UserBillGrowth",
        components: {
            Loading
        },
        props: {},
        data: function() {
            return {
              showno:1,
                where: {
                    page: 1,
                    limit: 20
                },
              all_money:0,
              ed_money:0,
              last_money:0,
              day_money:0,
              cancel_money:0,



                list: [],
                loaded: false,
                loading: false
            };
        },

        mounted: function() {
            let that = this;
            that.getIndex();
            that.$scroll(that.$refs.container, () => {
            !that.loading && that.getIndex();
        });
        },
        methods: {

            getIndex: function() {
                let that = this;
                if (that.loaded == true || that.loading == true) return;
                that.loading = true;
              getCommissionGrowth(that.where).then(
                    res => {
                        that.loading = false;
                        that.loaded = res.data.list.length < that.where.limit;
                        that.where.page = that.where.page + 1;
                        that.list.push.apply(that.list, res.data.list);

                        that.all_money = res.data.all_money;
                        that.ed_money = res.data.ed_money;
                        that.last_money = res.data.last_money;
                        that.day_money = res.data.day_money;
                        that.cancel_money = res.data.cancel_money;

                      if(that.list.length==0){
                        that.showno=0;
                      }else{
                        that.showno=1;
                      }
                    },
                    error => {
                        that.$dialog.message(error.msg);
                    }
            );
            }
        }
    };
</script>
